export default __webpack_public_path__ + "static/about-us-d784bd0e5369e13fab1e4853bcd13ce6.png";